import {createFileRoute} from '@tanstack/react-router';
import {PaymentCallbackErrorPage} from 'features/shared/payment/pages/PaymentCallbackErrorPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/callback/_statuses/error',
)({
  component: () => (
    <PaymentCallbackErrorPage
      pageId="bill_payment_error"
      navigateTo="/home/statements"
    />
  ),
});
